import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { radiologyTestsApi, CreateRadiologyTestDto, UpdateRadiologyTestDto } from '../api/radiologyTests.api';

export const useRadiologyTests = () => {
  return useQuery({
    queryKey: ['radiology-tests'],
    queryFn: () => radiologyTestsApi.getAll(),
    staleTime: 5 * 60 * 1000, // 5 minutes - data is fresh for 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes - cache for 10 minutes
  });
};

export const useCreateRadiologyTest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (newRadiologyTest: CreateRadiologyTestDto) => radiologyTestsApi.create(newRadiologyTest),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['radiology-tests'] });
      queryClient.invalidateQueries({ queryKey: ['prescription-initial-data'] });
    },
  });
};

export const useUpdateRadiologyTest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: UpdateRadiologyTestDto }) => radiologyTestsApi.update(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['radiology-tests'] });
      queryClient.invalidateQueries({ queryKey: ['prescription-initial-data'] });
    },
  });
};

export const useDeleteRadiologyTest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => radiologyTestsApi.remove(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['radiology-tests'] });
      queryClient.invalidateQueries({ queryKey: ['prescription-initial-data'] });
    },
  });
};

